import comp from "./PostDetailComp";
export default comp;
